import {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'

const LEGACY_WRAPPER = 'legacy'
const CHECKED_ID = 'checked'
const UNCHECKED_ID = 'unchecked'

const FormHasOnlineFinancing = ({onChange, type, value, wrapper = LEGACY_WRAPPER}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const {FILTERS_GROUPS_IDS} = config.get('filtersGroups')

  const _handleChange = (e, {checked}) => {
    onChange(e, {
      field: FILTER_NAMES.HAS_ONLINE_FINANCING,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.HAS_ONLINE_FINANCING],
      value: checked
    })
  }

  const handleChange = ({value: selectedValue}) => {
    const [currentValue] = selectedValue
    _handleChange(null, {checked: currentValue === CHECKED_ID})
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          name: FILTER_NAMES.HAS_ONLINE_FINANCING,
          options: [{id: CHECKED_ID, label: i18n.t('FILTER.HAS_ONLINE_FINANCING.LABEL')}],
          type
        }
      ]}
      group={FILTERS_GROUPS_IDS.ONLINE_SERVICES_GROUP_ID}
      helpText={i18n.t('FILTER.HAS_ONLINE_FINANCING.HELP_TEXT')}
      legend={i18n.t('FILTER.HAS_ONLINE_FINANCING.LABEL')}
      onChange={handleChange}
      value={{[FILTER_NAMES.HAS_ONLINE_FINANCING]: [value ? [CHECKED_ID] : [UNCHECKED_ID]]}}
      wrapper={wrapper}
    />
  )
}

FormHasOnlineFinancing.displayName = 'FormHasOnlineFinancing'
FormHasOnlineFinancing.propTypes = {
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  value: PropTypes.number,
  wrapper: PropTypes.string
}

const FormHasOnlineFinancingMemo = memo(FormHasOnlineFinancing)
FormHasOnlineFinancingMemo.displayName = 'FormHasOnlineFinancing'
export default FormHasOnlineFinancingMemo
